export default "__VITE_PUBLIC_ASSET__d28ef990__"